<template>
    <div>
        <v-layout>
            <v-tabs v-model="tab"
                    slider-color="white"
                    style="padding: 10px"
            >
                <v-tabs-slider color="#2196F3"></v-tabs-slider>
                <v-tab
                        v-for="item in productTypeList"
                        :key="item.code"
                        @click="changeProductType(item)"
                >
                    {{item.name }}
                </v-tab>
            </v-tabs>
        </v-layout>
        <v-layout wrap>
            <v-flex lg2 md2 sm2 xs2>
                <material-type-list :defaultData="types" @getMaterialType="getMaterialType" @onView="onViewType" :product-type="productType"/>
            </v-flex>
            <v-flex lg10 md10 sm10 xs10>
                <c-search-form
                        :fields="fields"
                        :form-name="formName"
                        :hiddenFields="hiddenFields"
                        :reload="timeReload"
                        :rows-per-page-items="[10, 20, 50]"
                        @createNew="openCreateDialog"
                        @editItem="openCreateDialog"
                        create-url="/material/save"
                        custom-create-new
                        custom-edit-item
                        delete-url="/material/delete"
                        form-type="intable"
                        key-property="materialId"
                        ref="tableData"
                        search-url="/material/search?sortField=createdAt&"
                        :deleteMulti="false"
                        orderBy="desc"
                        :acceptDelete="false"
                        @openHistoryDialog="openHistoryDialog"
                />
            </v-flex>
        </v-layout>

        <material-create
                :cDialog="visibleCreateDialog"
                :countrys="countrys"
                :packs="packs"
                :propsItem="material"
                :supplys="supplys"
                :types="types"
                :units="units"
                :hiddenFields="hiddenFields"
                @closeCreateDialog="closeCreateDialog"
                :formCreateName="formCreateName"
        />
      <feature-log ref="featureDlg"/>
    </div>
</template>

<script>

    import CSearchForm from "../../../components/form/ManageForm";
    import MaterialCreate from "./MaterialCreate.vue";
    import axios from "axios";
    import MaterialTypeList from "./component/MaterialTypeList";
    import {cateContants} from "@/constants";
    import FeatureLog from "../FeatureLog";

    export default {
        name: "material",
        components: {MaterialTypeList, MaterialCreate, CSearchForm, FeatureLog},
        data: () => {
            return {
                tab:null,
                formName: "Vật tư",
                formCreateName: 'Thêm mới vật tư',
                material: null,
                visibleCreateDialog: false,
                units: [],
                types: [],
                countrys: [],
                productTypeList: [
                    {name: "Vật tư nuôi", code: "VTN"},
                    {name: "Tài sản cố định", code: "TSCD"},
                    {name: "Công cụ, dụng cụ", code: "CCDC"},
                    {name: "Vật tư phụ", code: "VTK"},
                ],
                productType:"VTN",
                packs: [],
                supplys: [],
                timeReload: 0,
                typeId: 0,
                hiddenFields: {
                    typeId: "-1",
                    productType: "VTN"
                },
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "materialCode",
                        text: "Mã",
                        width: "5%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center; width: 100px;",
                    },
                    {
                        value: "materialName",
                        text: "Tên",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center; width: 120px;",
                    },
                    {
                        value: "pack",
                        text: "Đóng gói",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "unit",
                        text: "Đơn vị",
                        width: "5%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "manufacturer",
                        text: "NSX/Xuất xứ",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        value: "supplyId",
                        text: "Nhà cung cấp",
                        width: "15%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center; width: 130px;",
                        type: "select",
                        name: 'supplyId',
                        items: [],
                        itemText: "partnerName",
                        itemValue: "partnerId",
                    },
                    {
                        value: "note",
                        text: "Ghi chú",
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:center",
                    },
                    {
                        width: "12%",
                        value: "status",
                        text: "lang.user.status",
                        search: true,
                        headerStyle: "text-align:center",
                        type: "select",
                        name: "status",
                        items: cateContants.materialStatus,
                        itemText: "text",
                        itemValue: "value",
                    },
                  {
                    value: 'custom_action_list',
                    text: "lang.common.actions",
                    width: "150px",
                    items: [
                      {
                        text: "Sửa",
                        icon: "edit",
                        event: "editItem",
                        color: "primary"
                      },
                      {
                        text: "Lịch sử",
                        icon: "mdi-history",
                        event: "openHistoryDialog",
                        color: "primary"
                      },
                    ],

                  }
                ],
            };
        },

        created() {
            // unit
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=UNIT"
            )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.units = data;
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "unitId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );

            // country
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=ALL_COUNTRY&sortField=categoryName&orderBy=asc"
            )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.countrys = data;
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "countryId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );

            // pack
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=PACk"
            )
                .then(
                    (data) => {
                        if (data.length > 0) {
                            this.packs = data;
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "packId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data;
                            }
                        }
                    }
                );

            // type
            this.getMaterialType();

            // supply
            axios.post(
                process.env.VUE_APP_API_URL + "/partner/search?pageSize=-1&page=-1&orderBy=asc",
                 {typeId: 340}
            )
                .then(
                    (data) => {
                        if (data.items) {
                            this.supplys = data.items;
                            let itemFields = this.fields.filter(function (e) {
                                return e.name == "supplyId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data.items;
                            }
                        }
                    }
                );
        },
        mounted(){
          this.reload = Math.random();
          this.hiddenFields = Object.assign({}, this.hiddenFields)
        },
        methods: {
            openCreateDialog: function (item = null) {
                this.material = item;
                if (item == null) {
                    this.formCreateName = 'Thêm mới vật tư';
                } else {
                    this.formCreateName = 'Cập nhật vật tư';
                }
                this.visibleCreateDialog = true;
            },
            closeCreateDialog: function () {
                this.material = null;
                this.visibleCreateDialog = false;
                this.timeReload = Math.floor(Math.random() * 100);
            },
            changeProductType(item){
                this.productType = item.code;
                this.getMaterialType();
                this.onViewType({categoryId:0});
            },
            getMaterialType: function () {
                axios.post(
                    process.env.VUE_APP_API_URL + "/category/listByTypeAndCodeAuthenticateArea?type=MATERIAL_TYPE&code="+this.productType
                )
                    .then(
                        (data) => {
                            if (data.length > 0) {
                                this.types = data;
                                let itemFields = this.fields.filter(function (e) {
                                    return e.name == "typeId";
                                });
                                if (itemFields != undefined && itemFields.length > 0) {
                                    itemFields[0].items = data;
                                }
                            } else {
                                this.types = [];
                            }
                        }
                    );
            },
            onViewType(item) {
                if (item.categoryId != 0) {
                    this.hiddenFields = Object.assign({}, {"typeId": item.categoryId,"productType":this.productType});
                } else {
                    this.hiddenFields = Object.assign({}, {"typeId": -1,"productType":this.productType});
                }
            },
            formatSupplyName(item) {
                const stringUser = item.supplyId
                const uArr = stringUser.split(",");

                const famers = this.supplys.filter(function (e) {
                    return uArr.indexOf(String(e.categoryId)) != -1;
                });
                let listUser = ''
                if (famers) {
                    $.each(famers, function (k, v) {
                        if (k == 0) {
                            listUser += v.categoryName;
                        } else {
                            listUser += ", " + v.categoryName;
                        }
                    });
                }
                return listUser;
            },
          openHistoryDialog(item = null){
            console.log(item);
            if(item == null){
              return;
            }
            this.$refs.featureDlg.onSearch("material",item.materialId);

          },
        },

        destroyed() {
        },
    };
</script>
